import _Set from "@babel/runtime-corejs3/core-js/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import { useInstance, onMounted } from 'intact-vue-next';
import { useRecordParent } from '../../hooks/useRecordComponent';
import { inArray } from '../table/useChecked';
import { useState } from '../../hooks/useState';
export var MENU_RECORD_KEY = 'MenuKeys';
export function useHighlight() {
  var instance = useInstance();
  var menuItems = useRecordParent(MENU_RECORD_KEY);
  var highlightedKeys = useState([]);
  instance.watch('selectedKey', updateStatus, {
    presented: true
  });
  function updateStatus(newValue) {
    var _loop = function _loop() {
        var menuItem = menuItems[i];
        var key = menuItem.get('key');
        if (newValue !== key) return 0; // continue
        var items = [];
        var parentItem = menuItem.parentMenuItem;
        while (parentItem) {
          items.push(parentItem);
          parentItem = parentItem.parentMenuItem;
        }
        var expandedKeys = new _Set(instance.get('expandedKeys'));
        highlightedKeys.set(_mapInstanceProperty(items).call(items, function (item) {
          var key = item.get('key');
          expandedKeys.add(key);
          return key;
        }));
        instance.set('expandedKeys', _Array$from(expandedKeys));
        return {
          v: void 0
        };
      },
      _ret;
    for (var i = 0; i < menuItems.length; i++) {
      _ret = _loop();
      if (_ret === 0) continue;
      if (_ret) return _ret.v;
    }
    highlightedKeys.set([]);
  }
  function isHighlighted(key) {
    return inArray(highlightedKeys.value, key);
  }
  function select(key) {
    instance.set('selectedKey', key);
  }
  function isSelected(key) {
    return instance.get('selectedKey') === key;
  }
  return {
    isHighlighted: isHighlighted,
    select: select,
    isSelected: isSelected,
    updateStatus: updateStatus
  };
}
export function useHighlightItem() {
  var instance = useInstance();
  onMounted(function () {
    if (instance.rootMenu.get('selectedKey') == instance.get('key')) {
      var _instance$rootMenu$hi;
      (_instance$rootMenu$hi = instance.rootMenu.highlight) == null || _instance$rootMenu$hi.updateStatus(instance.get('key'));
    }
  });
}